import Vue from "vue";
import VueI18n from "vue-i18n";
import { detectLanguage } from "./languageDetector";

// Importar archivos de traducción
import es from "../locales/es.json";
import en from "../locales/en.json";
import ptBr from "../locales/pt-br.json";

Vue.use(VueI18n);

const messages = {
  es,
  en,
  "pt-br": ptBr,
};

// Detectar idioma automáticamente
const initialLocale = detectLanguage();

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: "es",
  messages,
  silentTranslationWarn: process.env.NODE_ENV === "production",
});

export default i18n;
